const error = [
    {
        name: 'objectError',
        execute: (value) => {
            if(value !== null && typeof value === 'object'){
                let obj = Object.values(value);
                let msg = [];
                for(var i = 0; i < obj.length; i++){
                    msg.push(obj[i][0]);
                }
                return msg;
            }
            return value;
        }
    }
];
export default error